import React from 'react';
import PropTypes from 'prop-types';
import { ShippingThreshold } from './ShippingThreshold';
import {
  formatDate,
  showTodayOrTomorrow,
  showDateOrDateRange,
  formatInventory
} from '../../../helper/utils';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { FULFILLMENT_METHODS } from '../../../constants';

const DefaultShipping = ({
  deliveryStartDate,
  deliveryEndDate,
  deliveryTimeline,
  type,
  hasFreeShipping,
  freeDeliveryThreshold,
  totalCharge,
  maxInventoryAvail,
  backordered,
  testID
}) => {
  const formattedStartDate = formatDate(deliveryStartDate);
  const formattedEndDate = formatDate(deliveryEndDate);
  const formattedInventoryQty = formatInventory(maxInventoryAvail);

  return (
    <div className="fulfillment-tile" data-testid={testID}>
      <TileHead
        title="Delivery"
      />
      <div className="fulfillment__sub-title">
        {(deliveryStartDate || deliveryEndDate) && (
          formattedStartDate === formattedEndDate ? (
            <span className="u__bold">
              {showTodayOrTomorrow(deliveryEndDate, true, deliveryTimeline, formattedEndDate)}
            </span>
          ) : (
            <span className="u__bold">
              {showDateOrDateRange({ formattedStartDate, formattedEndDate })}
            </span>
          )
        )}
        {backordered && type === FULFILLMENT_METHODS.STH_FFM ? (
          <div className="fulfillment-qty-row">Backordered</div>
        ) : !!formattedInventoryQty && (
          <div className="fulfillment-qty-row">
            <span className="u__text--success">{formattedInventoryQty}</span> available
          </div>
        )}
      </div>
      <TileFooter>
        <ShippingThreshold
          type={type}
          hasFreeShipping={hasFreeShipping}
          freeDeliveryThreshold={freeDeliveryThreshold}
          totalCharge={totalCharge}
        />
      </TileFooter>
    </div>
  );
};

DefaultShipping.propTypes = {
  deliveryStartDate: PropTypes.string,
  deliveryEndDate: PropTypes.string,
  deliveryTimeline: PropTypes.string,
  type: PropTypes.string,
  hasFreeShipping: PropTypes.bool,
  freeDeliveryThreshold: PropTypes.number,
  totalCharge: PropTypes.number,
  maxInventoryAvail: PropTypes.number,
  backordered: PropTypes.bool,
  testID: PropTypes.string
};

DefaultShipping.defaultProps = {
  deliveryStartDate: null,
  deliveryEndDate: null,
  deliveryTimeline: null,
  type: null,
  hasFreeShipping: false,
  freeDeliveryThreshold: null,
  totalCharge: null,
  maxInventoryAvail: null,
  backordered: false,
  testID: ''
};

export { DefaultShipping };
